/* eslint no-template-curly-in-string: 0 */
// import { FLOW_TYPES, PAYMENT_NETWORKS, PAYMENT_STATUSES } from "../../utils/enums";
import { FLOW_TYPES, PAYMENT_NETWORKS } from "../../utils/enums";
import mastercardLogo from "../../assets/images/mastercard-logo.png";

// const faq = {
//   question: "Mastercard Digital Debit Card Disclosures",
//   answer: "Upon redeeming, you will be asked to agree to the <strong><a target=\"_blank\" href=\"https://tremendous-assets.s3.amazonaws.com/documents/Patriot+Prefunded+Debit+Card+Terms.pdf\">Cardholder Agreement</a></strong> and <strong><a target=\"_blank\" href=\"https://www.patriot-bank.com/privacy.aspx\">Privacy Policy</a></strong>. By redeeming, you agree to the <strong><a target=\"_blank\" href=\"https://tremendous.notion.site/Tremendous-E-Sign-Consent-a841b407e8074510b36ab726baabb66c\">E-Sign Disclosure</a></strong>. South State Bank is not a sponsor of the selected reward.<br/><br/>Inactivity Fee after 12 months of no use is $3.95 per month. Cards will never go into negative balance or charge the card holder.<br/><br/>Your card can be used at any merchant in the United States and District of Columbia where Mastercard is accepted. However, whether or not the specific merchant accepts prepaid cards as payment is at their discretion. Information about using the card can be found here: <strong><a target=\"_blank\" href=\"https://tremendous.notion.site/Frequently-Asked-Questions-64ba1a58cb3243949671e7e5237bcc21\">Frequently Asked Questions</a></strong>."
// };

export const dashVirtualMastercard = {
  id: PAYMENT_NETWORKS.VIRTUALDEBITCARD_DASH_MASTERCARD,
  displayName: "Mastercard Digital Debit Card",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: ["Mastercard Digital Debit Card"],
      tagline: [
        {
          type: 'div',
          string: "Delivered within two weeks",
        }
      ],
      description: [
        {
          string: 'For use online or in-store (via a mobile wallet)',
          type: 'div'
        },
        {
          string: "(Inactivity fees occur if not used in a 12 month period)",
          type: 'div',
          props: {
            style: {
              fontSize: '0.9em',
              color: '#ff0000'
            }
          }
        }
      ],
      // btnLabel: "Next",
      logo: mastercardLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Mastercard"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.BASIC,
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Mastercard Digital Debit Card, which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail'
        }
      }
    ],
    disclaimer: [
      {
        string: 'We encourage you to use your card once every 12 months to avoid inactivity fees. A monthly inactivity fee of $0.95 will occur after one year of inactivity.',
        props: {
          style: {
            fontSize: "0.8rem",
            lineHeight: "1.2",
            padding: "0 1em",
            display: "block",
            textAlign: "center",
            marginBottom: "2em",
          }
        }
      }
    ],
    imgSrc: mastercardLogo,
    btnLabel: 'Accept Mastercard'
  },
  paymentComplete: {
    initial: {
      description: [
        "Please check your email",
        " for a message from support@card-support.com,",
        " which will provide your card details.",
      ],
      secondaryText: "Treat your card like cash and care for it accordingly to avoid loss or theft. Remember to use your card once every 12 months to avoid inactivity fees.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your Mastercard Digital Debit Card.",
      ],
      secondaryText: "Treat your card like cash and care for it accordingly to avoid loss or theft. Remember to use your card once every 12 months to avoid inactivity fees.",
    },
    imgSrc: mastercardLogo,
  },
  networkSelectionAccepted: {
    imgSrc: mastercardLogo,
    title: ["Success!"],
    description: [
      "Please check your email",
      " for a message from support@card-support.com,",
      " which will provide your card details.",
    ],
    secondaryText: "Treat your card like cash and care for it accordingly to avoid loss or theft. Remember to use your card once every 12 months to avoid inactivity fees.",
  },
};

export default dashVirtualMastercard;
